import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=c5b0ed20&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=c5b0ed20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b0ed20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5b0ed20')) {
      api.createRecord('c5b0ed20', component.options)
    } else {
      api.reload('c5b0ed20', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=c5b0ed20&scoped=true&", function () {
      api.rerender('c5b0ed20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2J9hlIXyWNHpR/JS/teamMember.vue"
export default component.exports